export default "__VITE_ASSET__BbDUP1Ua__"